import Circle from '@mui/icons-material/Circle';
import { Divider } from '@mui/material';
import Heading from 'components/design-system/Heading/Heading';
import { RoleComponent } from 'components/design-system/Role/Role';
import Text from 'components/design-system/Text/Text';

/**
 * @name DescripcionDemandante
 * Despliega la descripción de la oferta de residuo para un publicante con rol demandante.
 */
export const DescripcionDemandante = ({ residuo }) => {
  return (
    <div>
      <Divider className="my-3" />
      <RoleComponent rol={residuo.rol.nombreRol} tipo="etiqueta" />

      <div className="pl-3">
        <Heading type="h5">{residuo.nombreResiduo}</Heading>
        <div className="grid grid-cols-12 gap-2 items-baseline">
          <div className="col-span-4">
            <span className="block font-secondary text-xs text-neutral-60 tracking-wider font-normal pt-0.5">
              RESIDUO
            </span>
          </div>
          <div className="col-span-8">
            <Text>{residuo?.tipoResiduo || ''}</Text>
          </div>
          <div className="col-span-4">
            <span className="block font-secondary text-xs text-neutral-60 tracking-wider font-normal pt-0.5">
              RECURSOS
            </span>
          </div>
          <div className="col-span-8">
            {residuo.recursos.map((recurso, index) => (
              <Text key={index} className="mb-2 relative gap-2 flex">
                <Circle className="text-uv-secondary-0 w-1.5 h-1.5 mt-1.5 top-0.5 relative" />
                {recurso.nombreRecurso}
              </Text>
            ))}
          </div>

          {residuo.descripcionAdicional && (
            <>
              <div className="col-span-4">
                <span className="block font-secondary text-xs text-neutral-60 tracking-wider font-normal pt-0.5">
                  DESCRIPCIÓN
                </span>
              </div>
              <div className="col-span-8">
                <Text>{residuo.descripcionAdicional}</Text>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
